import urlUtils from "../../utils/urlUtils";
import {useModal} from "./useModal";
import {useEffect, useState} from "preact/hooks";
import httpClient from "../../utils/httpClient";
import {useInterval} from "../../utils/hooks";
import {FreeUnitEnum} from "../../utils/enums";

const spaceKey = urlUtils.getSpaceKey();
const isEmbeddedLoader = urlUtils.isEmbeddedLoader();
const range = 5; // 元
const timeRange = 10; // 分钟

/**
 * 返回true则打开
 * @param {string} sessionKey
 * @returns
 */
function shouldOpen(sessionKey) {
    const val = sessionStorage.getItem(sessionKey)
    if (!val) {
        sessionStorage.setItem(sessionKey, `${Date.now()}::${1}`)
        return true
    }
    const [tiemstamp, count] = val.split('::').map(item => Number(item))
    if (count >= 2) {
        return false
    }
    const now = Date.now()
    // 10分钟
    if (now - tiemstamp < 1.5 * 60 * 1000) {
        return false
    }
    const newCount = count + 1
    sessionStorage.setItem(sessionKey, `${now}::${newCount}`)
    return true
}

export function MyModal({ config }) {
    const {show, hide, RenderModal} = useModal();
    const [modalType, setModalType] = useState('modal1');
    const [balance, setBalance] = useState(0);
    const [leftTimeText, setLeftTimeText] = useState('1 分钟');
    const [workspaceType, setWorkspaceType] = useState(''); // NORMAL 为普通工作空间
    // 默认为 true 支持包月
    const [hasResourceBag, setHasResourceBag] = useState(true);
    const getModalInfo = (modalType) => {
        const map = {
            modal1: {
                title: '充值金额即将用尽提醒',
                content: '您的充值金额即将使用完毕，当前余额为 {{balance}} 元，请问是否充值并继续使用？',
                onOk() {
                    hide();
                    const win = isEmbeddedLoader ? parent.window : window;
                    win.location.href = config.rechargeUrl || '/dashboard/account-recharge';
                }
            },
            modal2: {
                title: '欠费额度即将用尽提醒',
                content: '您的欠费额度即将使用完毕， 您有 {{balance}} 元的欠费，将无法打开工作空间。您可选择缴清欠费并充值来继续使用。',
                onOk() {
                    hide();
                    const win = isEmbeddedLoader ? parent.window : window;
                    win.location.href = config.rechargeUrl || '/dashboard/account-recharge';
                }
            },
            modal3: {
                title: '免费赠送时长即将用尽提醒',
                content: '您的免费赠送时长即将用尽， 当前剩余免费时长为 {{leftTimeText}}，请问是否充值并继续使用？',
                onOk() {
                    hide();
                    const win = isEmbeddedLoader ? parent.window : window;
                    win.location.href = config.rechargeUrl || '/dashboard/account-recharge';
                }
            },
            modal4: {
                title: '欠费提醒',
                content: '您好，您当前的腾讯云账户已经欠费， 请尽快充值，否则将无法正常打开工作空间。您可选择缴清欠费并充值来继续使用，请问是否充值并继续使用？',
                onOk() {
                    hide();
                    const win = isEmbeddedLoader ? parent.window : window;
                    win.location.href = config.rechargeUrl || '/dashboard/account-recharge';
                }
            }
        }
        return map[modalType];
    };
    const modalInfo = getModalInfo(modalType);
    useEffect(() => {
        async function fetch() {
            const requestList = [
                httpClient({
                    path: `/workspace/${spaceKey}/loadingStatus`,
                    method: "GET",
                }),
                httpClient({
                    path: `/workspace/${spaceKey}/payBags`,
                    method: "GET",
                })
            ];
            const [res, res2] = await Promise.all(requestList)
            if (res && res.code === 0 && res.data) {
                setWorkspaceType(res.data.workspaceType || '');
            }
            if (res2 && res2.code === 0 && Array.isArray(res2.data) && res2.data.length === 0 ) {
                setHasResourceBag(false);
            }
        }
        fetch();
    }, [])

    // 轮询请求 - 工作空间状态
    useInterval(
        () => {
            const fetchData = async () => {
                const res = await httpClient({
                    path: `/account`,
                    method: "GET",
                });
                if (res.code === 0 && res.data) {
                    const accountData = res.data;
                    const leftFree = accountData.leftFree; // 剩余免费时长
                    const freeUnit = accountData.freeUnit; // 剩余免费时长单位
                    const balance = ((accountData.balance + accountData.subsidy) / 100);
                    setBalance(balance);
                    // 透支额度, 小于0时可无限透支(内部用户)
                    const overdraft = (accountData.overdraft / 100);
                    // 非内部用户 并且 非FREE规格 才提醒
                    if (overdraft >= 0 && config.spec !== 'FREE') {
                        if (config.isTencentCloud) {
                            // 腾讯云帐户欠费提醒
                            // accountData.balance === -1 约定值，腾讯云帐户欠费
                            if (accountData.balance === -1 && shouldOpen('modal4')) {
                                setModalType('modal4');
                                show();
                                return;
                            }

                            // 免费赠送时长即将用尽提醒
                            if (leftFree > 0 && leftFree <= timeRange && shouldOpen('modal3')) {
                                setLeftTimeText(`${leftFree} ${FreeUnitEnum[freeUnit] || '分钟'}`);
                                setModalType('modal3');
                                show();
                                return;
                            }
                        } else {
                            // 赠送时长已用完
                            if (leftFree <= 0) {
                                // 欠费额度将用尽提醒
                                if (balance < 0 && Math.abs(balance) >= (overdraft - range) && shouldOpen('modal2')) {
                                    setModalType('modal2');
                                    show();
                                    return;
                                }
                                // 充值金额即将用尽提醒
                                if (balance > 0 && balance <= range && shouldOpen('modal1')) {
                                    setModalType('modal1');
                                    show();
                                    return;
                                }
                                return;
                            }
                            // 赠送时长快用完且账户余额为 0
                            // 免费赠送时长即将用尽提醒
                            if (leftFree > 0 && leftFree <= timeRange && balance === 0 && shouldOpen('modal3')) {
                                setLeftTimeText(`${leftFree} ${FreeUnitEnum[freeUnit] || '分钟'}`);
                                setModalType('modal3');
                                show();
                                return;
                            }
                        }
                    }
                }
            };
            fetchData();
        },
        workspaceType === 'NORMAL' && !hasResourceBag ? 1 * 60 * 1000 : undefined, // 1分钟
        {
            immediate: true
        }
    );

    const message = modalInfo.content.replace('{{balance}}', `${Math.abs(balance)}`).replace('{{leftTimeText}}', leftTimeText)

    return (
        <RenderModal title={modalInfo.title} onOk={modalInfo.onOk}>
              { message }
        </RenderModal>
    )
}
